const styles = theme => ({
    root: {
        marginTop: -10,
        marginLeft: `auto`,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'none'
        },
        [theme.breakpoints.up('md')]: {
          display: 'block'
        }
    },
    rootSeamless: {
      marginTop: 20,
      marginLeft: `auto`,
      marginRight: 50,
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      },
      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },
    email: {
      fontSize: 14,
      fontFamily: 'proximaNova-regular',
      marginTop: 12,
      marginBottom: 16,
      marginLeft: 12,
      marginRight: 12
    },
    avatar: {
      margin: 11,
      width: 36,
      height: 36,
      backgroundColor: 'rgba(200,200,200,1)',
      border:'2px solid rgba(255,255,255,1)',
      boxShadow: '0 0 0px 0px white',
      overflow: 'hidden',
      fontFamily: 'proximaNova-bold',
      fontSize: 12
    },
    indent: {
    },
    button: {
      borderRadius: 4,
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 5,
      paddingLeft: 0
    },
    text: {
      marginLeft: 2,
      color: 'white',
      textColor: 'white',
      textTransform: 'none',
      fontFamily: 'proximaNova-bold',
      fontSize: 15
    },
    textDark: {
      marginLeft: 6,
      marginTop: 2,
      color: 'black',
      textColor: 'black',
      textTransform: 'none',
      fontFamily: 'proximaNova-bold',
      fontSize: 15
    },
    icon: {
      color: 'white'
    },
    iconDark: {
      color: 'black'
    },
    menuList: {
      borderRadius: 4,
      boxShadow: '0 1px 3px 0px rgba(180, 180, 180, .6)'
    },
    menuItemTop: {
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      marginTop: 8
    },
    menuItemBottom: {
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4
    },
    menu: {
      minWidth: 120,
      borderRadius: 4,
      marginTop: 8
    }
});
  
export default styles;
  